import { useState, useEffect } from "react";
import NiceModal, { useModal, bootstrapDialog } from "@ebay/nice-modal-react";
import BootstrapModal from "react-bootstrap/Modal";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import React from "react";
import { toast } from "react-toastify";
import { instance } from "../axios";
import { useNavigate, useParams } from "react-router-dom";
import { UiSelect, UiInput, UiDatePicker, BgLoader, UiButton, OverlayLoader } from "../ui";
import generatePDF from '../bulk_pdf.js';

const generateYearList = () => {
  const currentYear = new Date().getFullYear();
  const startYear = currentYear - 10; // 10 years ago
  const endYear = currentYear + 1; // Current year + 1
  const years = [];

  for (let year = endYear; year >= startYear; year--) {
      years.push(year);
  }

  return years;
};
const months = [
  { label: 'January', value: '01' },
  { label: 'February', value: '02' },
  { label: 'March', value: '03' },
  { label: 'April', value: '04' },
  { label: 'May', value: '05' },
  { label: 'June', value: '06' },
  { label: 'July', value: '07' },
  { label: 'August', value: '08' },
  { label: 'September', value: '09' },
  { label: 'October', value: '10' },
  { label: 'November', value: '11' },
  { label: 'December', value: '12' }
];
const BulkPdf = NiceModal.create(
  ({ type, action, ids }) => {
    const [state, setState] = useState({ count: 0 });
    const modal = useModal();
    const [loader, showLoader] = useState(false);

    const schema = yup.object().shape({
      type: yup.string(),
      from: yup.string().nullable().when('type', {
        is: 'ledger',
        then: (rule) => rule.required("From date is required"),
      }),

      to: yup.string().nullable().when('type', {
        is: 'ledger',
        then: (rule) => rule.required("To date is required"),
      }),

      month: yup.string().nullable().when('type', {
        is: 'due_slip',
        then: (rule) => rule.required("Month is required"),
      }),

      year: yup.string().nullable().when('type', {
        is: 'due_slip',
        then: (rule) => rule.required("Year is required"),
      }),
    }, []);
    const {
      register,
      handleSubmit,
      control,
      unregister,
      formState: { errors },
      reset,
    } = useForm({
      resolver: yupResolver(schema),
    });
    const onSubmitHandler = async (data) => {
      SaveTag(data);
      //reset();
    };
    var SaveTag = (e) => {

      showLoader(true)

      const params = new URLSearchParams(e);

      let data = [];


      const promises = ids.map(party =>
        instance.get("/ledger?party=" + party + "&" + params.toString()).then(response => response.data)
      );

      Promise.all(promises)
        .then(responses => {
          showLoader(false)
          data = responses;
          generatePDF(data, action, type, showLoader);
          //showLoader(false)
          //modal.resolve({ resolved: true });
          //modal.hide();

        })
        .catch(error => {
          console.error('Error fetching data:', error);
          // Handle error, possibly show a message to the user
        });





    };






    useEffect(() => {
    }, []);



    const handleHide = () => {
      modal.hide();
    }




    return (
      <BootstrapModal {...bootstrapDialog(modal)} onHide={() => handleHide()}>
        <BootstrapModal.Header closeButton>
          <BootstrapModal.Title>{type == 'ledger' ? 'Ledger' : 'Due Slip'} Generate</BootstrapModal.Title>
        </BootstrapModal.Header>
        <OverlayLoader visible={loader} />
        <BootstrapModal.Body>

          <form id="waform" onSubmit={handleSubmit(onSubmitHandler)}>
            {type == 'ledger' ?
              <div className="row">
                <div className="col-6">

                  <Controller

                    name="from"
                    control={control}
                    render={({
                      field: { onChange, onBlur, value, name, ref },
                      fieldState: { invalid, isTouched, isDirty, error },
                      formState,
                    }) => (
                      <UiDatePicker
                        label="From"
                        onChange={onChange}
                        default_val={value}
                        message={errors.from?.message}
                        dateFormat="dd-MM-yyyy"
                        ref={ref}
                        name={name}
                      />
                    )}
                  />


                </div>

                <div className="col-6">

                  <Controller

                    name="to"
                    control={control}
                    render={({
                      field: { onChange, onBlur, value, name, ref },
                      fieldState: { invalid, isTouched, isDirty, error },
                      formState,
                    }) => (
                      <UiDatePicker
                        label="To"
                        onChange={onChange}
                        default_val={value}
                        message={errors.to?.message}
                        dateFormat="dd-MM-yyyy"
                        ref={ref}
                        name={name}
                      />
                    )}
                  />


                </div>

              </div>
              :
              <div className="row">
                <div className="col-6">
                  <UiSelect
                    name='month'
                    label="Month"
                    message={errors.month?.message}
                    //defaultValue={value.machine}
                    options={months}
                    {...register(`month`)}
                  />
                </div>
                <div className="col-6">
                <UiSelect
                    name='year'
                    label="Year"
                    message={errors.year?.message}
                    //defaultValue={value.machine}
                    options={generateYearList()}
                    {...register(`year`)}
                  />
                  </div>
              </div>
            }
            <UiInput type="hidden" name="type" value={type} {...register(`type`)} />
            <UiButton className="btn btn-primary" type="submit" title={action == "print" ? "Print" : "Send on Whatsapp"} />

          </form>

        </BootstrapModal.Body>

      </BootstrapModal>
    );
  }
);

export default BulkPdf;
